import { j as a } from "./jsx-runtime-DmTjM30f.mjs";
import { c as i } from "./tw-cn-mXgPecoF.mjs";
import { I as y } from "./icon-button-DImUgRzQ.mjs";
const j = ({ children: s, href: o, className: e, onClick: t }) => o ? /* @__PURE__ */ a.jsx("a", { className: e, href: o, onClick: t, children: s }) : /* @__PURE__ */ a.jsx("div", { className: e, onClick: t, role: "button", tabIndex: 0, children: s }), g = ({
  button: s,
  badge: o,
  className: e,
  pcType: t = "pcSize",
  theme: n = "ghost"
}) => {
  const c = t === "pcSize";
  return /* @__PURE__ */ a.jsxs(j, { className: i("relative cursor-pointer", e), href: s.href, onClick: s.onClick, children: [
    /* @__PURE__ */ a.jsx(
      y,
      {
        "aria-label": s["aria-label"],
        className: "active:bg-transparent hover-never:bg-transparent",
        icon: s.icon,
        size: c ? void 0 : "medium",
        theme: n
      }
    ),
    o
  ] });
}, v = 6, w = ({ item: s, pcType: o = "pcSize", transparent: e }) => {
  const { button: t, text: n } = s, c = n == null ? void 0 : n.substring(0, v), l = o === "pcSize";
  return t.href ? /* @__PURE__ */ a.jsx(
    "a",
    {
      className: i("w-84 whitespace-nowrap pr-10 text-right typography-body-14-bold", {
        "pc:typography-subtitle-16-bold": l,
        "text-static-white": e
      }),
      href: t.href,
      onClick: t.onClick,
      children: c
    }
  ) : /* @__PURE__ */ a.jsx(
    "button",
    {
      className: i("w-84 whitespace-nowrap pr-10 text-right typography-body-14-bold", {
        "pc:typography-subtitle-16-bold": l,
        "text-static-white": e
      }),
      onClick: t.onClick,
      onKeyDown: (x) => {
        (x.key === "Enter" || x.key === " ") && t.onClick();
      },
      type: "button",
      children: c
    }
  );
}, N = ({
  title: s = "",
  leftButton: o,
  rightButtons: e,
  deviceType: t = "etc",
  children: n,
  pcType: c = "pcSize",
  theme: l,
  ...x
}) => {
  const m = t === "android", b = (e == null ? void 0 : e.length) === 2 || (e == null ? void 0 : e[0].type) === "Text", p = c === "pcSize", d = l === "transparent", f = l === "ghost";
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: i("flex min-h-52 flex-row items-center gap-8 bg-static-white px-6 py-4 align-middle", {
        "pc:min-h-76 pc:gap-16 pc:px-10": p,
        "bg-transparent": d || f
      }),
      ...x,
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: i("flex w-full flex-wrap items-center gap-8", { "pc:gap-16": p, "gap-0": m }),
            children: [
              /* @__PURE__ */ a.jsxs("div", { className: i("flex gap-4", { "pc:gap-0": p }), children: [
                /* @__PURE__ */ a.jsx(
                  g,
                  {
                    button: o,
                    pcType: c,
                    theme: d ? "transparent" : "ghost"
                  }
                ),
                !m && b ? (
                  // title을 중앙으로 보내기 위한 빈 div
                  /* @__PURE__ */ a.jsx(
                    "div",
                    {
                      className: i("size-40 shrink-0", {
                        "pc:size-56": p
                      })
                    }
                  )
                ) : null
              ] }),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: i("w-full flex-1 overflow-hidden text-center typography-subtitle-18-bold", {
                    "pc:typography-headline-24-bold": p,
                    "text-left": m,
                    "line-clamp-1": !!s && !n,
                    "text-static-white": d
                  }),
                  children: n || s
                }
              )
            ]
          }
        ),
        e ? /* @__PURE__ */ a.jsx("div", { className: i("flex gap-4", { "pc:gap-0": p }), children: e.map(
          (r, h) => r.type === "Icon" ? /* @__PURE__ */ a.jsx(
            g,
            {
              badge: r.badge,
              button: r.button,
              pcType: c,
              theme: d ? "transparent" : "ghost"
            },
            `${r.button["aria-label"]}_${h.toString()}`
          ) : /* @__PURE__ */ a.jsx(
            w,
            {
              item: r,
              pcType: c,
              transparent: d
            },
            `${r.text}_${h.toString()}`
          )
        ) }) : (
          // title을 중앙으로 보내기 위한 빈 div
          /* @__PURE__ */ a.jsx(
            "div",
            {
              className: i("size-40 shrink-0", {
                "pc:size-56": p
              })
            }
          )
        )
      ]
    }
  );
};
N.displayName = "NDS.TopNavigation";
export {
  N as T,
  g as a,
  w as b
};
